import { render, staticRenderFns } from "./system-template-card.vue?vue&type=template&id=b2648bdc&scoped=true"
import script from "./system-template-card.vue?vue&type=script&lang=js"
export * from "./system-template-card.vue?vue&type=script&lang=js"
import style0 from "./system-template-card.vue?vue&type=style&index=0&id=b2648bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2648bdc",
  null
  
)

export default component.exports